import React from "react";
import { BASE_NAME } from "../../constants/FileConstants";
import { ExtractBaseURL } from "../ExtractBaseURL/ExtractBaseURL";

function InternalLinkData({ value, documentationSection }) {
  const convertStrToUrl = (str) => str.toLowerCase().split(" ").join("-");

  return (
    <a
      href={`${ExtractBaseURL()}${BASE_NAME}/documentation/${convertStrToUrl(
        documentationSection
      )}?value=${convertStrToUrl(value)}`}
    >
      {value}
    </a>
  );
}

export default InternalLinkData;
